import BaseService from "./BaseService";

export default class PagesService extends BaseService {
  static endPoint = "pages";
}
